import { apiClient, APIResponse, PaginatedResponse, QueryOptions } from './client';

export interface TeamMember {
  id: number;
  userid?: number;
  code?: string;
  firstname: string;
  lastname?: string;
  emailid: string;
  mobile?: string;
  department?: string;
  designation?: string;
  role?: string;
  /** This member's role IN THIS WORKGROUP (profileworkgroups.roleid -> roles.rolecode) -- distinct from `role`, the account-wide cosmetic job-title field. */
  workgrouprole?: string | null;
  /** The role's id, for preselecting it in the Change Role dialog. */
  workgrouproleid?: number | null;
  /** The role's display name -- shows correctly for custom (non-system) roles too, unlike a rolecode-keyed label switch. */
  workgrouprolename?: string | null;
  profiletype?: string;
  reportingmanagerid?: number;
  registeredon: string;
  status: string;
  timezone?: string;
  isactive: boolean;
  isarchived: boolean;
  createdon: string;
  createdby?: number;
  lastactivityon?: string;
  lastactivityby?: number;
  avatar?: string;

  reporting_manager_name?: string;
  reporting_manager_designation?: string;

  total_applications_created?: number;
  total_projects_created?: number;
  total_scans_created?: number;
  completed_scans?: number;
  failed_scans?: number;
  pending_scans?: number;
  avg_scan_duration_minutes?: number;
  total_vulnerabilities_found?: number;
  total_components_scanned?: number;
  avg_overall_score?: number;
  avg_vulnerability_score?: number;

  total_workgroups?: number;
  active_workgroups?: number;
  workgroup_names?: string;

  last_application_created?: string;
  last_project_created?: string;
  last_scan_created?: string;
  first_application_created?: string;
  first_project_created?: string;
  first_scan_created?: string;

  total_notifications?: number;
  unread_notifications?: number;
  read_notifications?: number;

  scan_success_rate?: number;
  activity_score?: number;
  profile_completeness_score?: number;
  performance_rating?: string;
  account_age_days?: number;
  account_status?: string;

  projects?: string[];
  permissions?: string[];
}

export interface CreateTeamData {
  name: string;
  description?: string;
  department?: string;
}

export interface UpdateTeamData {
  id: number;
  name?: string;
  description?: string;
  department?: string;
}

export interface FindTeamsOptions extends QueryOptions {

}

export class TeamAPI {
  static async getAll(options?: FindTeamsOptions) :Promise<APIResponse<PaginatedResponse<TeamMember>>> {
    return apiClient.get<PaginatedResponse<TeamMember>>('/teams', options);
  }
  static async getById(id: number) {
    return apiClient.get<TeamMember>(`/teams/${id}`);
  }
  static async create(data: CreateTeamData) {
    return apiClient.post<TeamMember>('/teams', data);
  }
  static async update(id: number, data: UpdateTeamData) {
    return apiClient.patch<TeamMember>(`/teams/${id}`, data);
  }
  static async delete(id: number) {
    return apiClient.delete<void>(`/teams/${id}`);
  }
    
  static async archive(id: number): Promise<APIResponse<void>> {
    return apiClient.delete<void>(`/teams/archive/${id}`);
  }
  static async getTeamMembers() {
    return apiClient.get<TeamMember[]>('/teams');
  }

  static async updateMemberRole(memberId: number, roleId: number) {
    return apiClient.patch<TeamMember>(`/teams/members/${memberId}/role`, { roleId });
  }

  static async updateMemberPermissions(memberId: number, permissions: any[]) {
    return apiClient.patch<TeamMember>(`/teams/members/${memberId}/permissions`, { permissions });
  }

  static async getMemberPermissions(memberId: number) {
    return apiClient.get<any[]>(`/teams/members/${memberId}/permissions`);
  }

  static async getModules() {
    return apiClient.get<any[]>('/teams/modules');
  }

  static async deactivateMember(memberId: number) {
    return apiClient.patch<void>(`/teams/members/${memberId}/deactivate`);
  }
  static async activateMember(memberId: number) {
    return apiClient.patch<void>(`/teams/members/${memberId}/activate`);
  }
  static async resetMemberPassword(memberId: number) {
    return apiClient.patch<{ tempPassword: string }>(`/teams/members/${memberId}/reset-password`);
  }
  static async deleteMember(memberId: number) {
    return apiClient.delete<void>(`/teams/members/${memberId}`);
  }

  static async archiveMemeber(id: number): Promise<APIResponse<void>> {
    return apiClient.delete<void>(`/teams/members/archive/${id}`);
  }
};
